const DEFAULT_PRIMARY = "#f07d00";

export function gradientToCss(gradient, fallbackColor = DEFAULT_PRIMARY) {
  if (!gradient || !Array.isArray(gradient.stops) || gradient.stops.length === 0) {
    return null;
  }

  const angle = Number.isFinite(Number(gradient.angle)) ? Number(gradient.angle) : 135;
  const sortedStops = [...gradient.stops]
    .filter((stop) => stop && stop.color != null)
    .map((stop) => ({
      color: String(stop.color),
      position: Number.isFinite(Number(stop.position)) ? Number(stop.position) : 0,
    }))
    .sort((a, b) => a.position - b.position);

  if (sortedStops.length === 0) {
    return null;
  }

  const stops = sortedStops.map((stop) => `${stop.color} ${stop.position}%`).join(", ");
  return `linear-gradient(${angle}deg, ${stops})`;
}

export function resolveBackgroundStyle(gradient, backgroundColor, fallbackColor = DEFAULT_PRIMARY) {
  return gradientToCss(gradient, fallbackColor) || backgroundColor || "transparent";
}

